<template>
    <section id="section-search" class="section-search">
        <div class="search">
            <input @keyup.enter="filterData" v-model="searchInput" type="text"
                   class="search__input" placeholder="Search articles. Reset with empty search">
            <button @click="filterData" class="search__button">
                <svg class="search__icon">
                    <use xlink:href="/img/sprite.svg#icon-magnifying-glass"/>
                </svg>
            </button>
        </div>
        <div v-if="updateStats.totalSelectedArticlesLength" class="stats">
            <span class="stats__year"> Year: </span>
            <span>{{updateStats.year}}</span>
            <span class="stats__total">Articles: </span>
            <span>{{updateStats.totalSelectedArticlesLength}}</span>
        </div>
    </section>
</template>

<script>
    export default {
        // name: "SearchArticle",
        components: {},
        data() {
            return {
                searchInput: '',
                year: null,
                totalSelectedArticlesLength: null,
                start: 0,
                end: 200
            }
        },
        computed: {
            updateStats() {
                let year = this.$store.getters.yearArticles;//data.year;
                let totalSelectedArticlesLength = this.$store.getters.totalSelectedArticles;//data.totalSelectedArticlesLength
                return ({year: year, totalSelectedArticlesLength: totalSelectedArticlesLength})
            }
        },
        created() {
        },
        methods: {
            filterData() {
                this.$eventHub.$emit('filter-input-data', this.searchInput);
                this.searchInput = '';
            }
        }
    }
</script>

<style lang="scss" scoped>


</style>
